import { render } from "./CompanySettings.vue?vue&type=template&id=17f3f46c&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"

import "./CompanySettings.vue?vue&type=style&index=0&id=17f3f46c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f3f46c"]])

export default __exports__